import camelCase from "./utils/camelCase";
import facetwpPagination from "./utils/pagination";
import alertPopupFunctionality from "./utils/alerts-popups";
import mktoFiltering from "./utils/mktoFilters";
import { menu, menuButton } from "./menu";
import { demoModal } from "./demoModal";
import { modal } from "./modal";
import AOS from "aos";

const checkForElement = (element) => {
  if (typeof element != "undefined") {
    return element;
  }
  return false;
};
document.addEventListener("DOMContentLoaded", menu);
document.addEventListener("DOMContentLoaded", menuButton);
document.addEventListener("DOMContentLoaded", demoModal);
document.addEventListener("DOMContentLoaded", modal);
document.addEventListener("DOMContentLoaded", alertPopupFunctionality());
//document.addEventListener("DOMContentLoaded", mktoFiltering());

// run Facetwp pagination function when facetwp-loaded event fires
document.addEventListener("facetwp-loaded", facetwpPagination);

document.addEventListener("DOMContentLoaded", () => {
  // *******
  // AOS stuff
  // *******

  // init AOS
  var aosOffset = -150,
    aosDuration = 400;
  if ($("#mobile-tester").is(":visible")) {
    aosOffset = -50;
    aosDuration = 450;
  }

  AOS.init({
    duration: aosDuration,
    easing: "ease-out-cubic",
    startEvent: "load",
    offset: aosOffset,
    once : true
  });
});
document.addEventListener("DOMContentLoaded", () => {

  // set assetId value, if it exists
  let idDiv = document.getElementById('spotAssetId');
  let assetId = undefined;
  if (idDiv) {
    assetId = idDiv.attributes.name.value;
  }

  let name = "spotAssetIdCookie";
  // if an assetId exists, set/rewrite the session cookie
  if (assetId) {
    document.cookie = name + "=" + assetId + ";" + "path=/;";
  }

  // allow demo form elements to fully load
  setTimeout(function() {
    // target assetId hidden field
    const assetIdField = document.querySelectorAll('[name="mktoSpotAssetID"]');
    if (assetIdField.length > 0 && getCookieValue(name) !== undefined) {
      assetIdField[0].setAttribute('value', getCookieValue(name));
    }
  }, 2000);

  // utility function to get cookie value by name
  const getCookieValue = (cname) => (
    document.cookie.match('(^|;)\\s*' + cname + '\\s*=\\s*([^;]+)')?.pop() || ''
  );
  
});
document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".husl-block");
  if (!blocks.length) return;

  var blocksArray = [];
  blocks.forEach(async (module) => {
    let name = checkForElement(module.dataset.block);
    if (name) {
      name = camelCase(name);
      if ($.inArray(name, blocksArray) == -1) {
        blocksArray.push(name);
      }
    } else {
      console.error("No block name found");
      return;
    }
  });

  if (blocksArray.length) {
    blocksArray.forEach(async (name) => {
      try {
        const { Block } = await import(/* webpackChunkName: 'block' */ `./blocks/${name}`);
        const block = new Block(name);
        block.init();
      } catch (error) {
        console.log(error);
        console.warn(
          `You're missing the js file for the ${name} block. \n Create the missing file inside the blocks folder: nylon/assets/js/blocks/${name}.js`
        );
      }
    });
  }
});
    
    
// ****
// Search post type filter
// ****

if ($('#search-form-filter').length) {
  var urlParams = new URLSearchParams(window.location.search),
      sources = [],
      search = urlParams.get('s');

  // loop through params
  // if you see one with 'sources', store it
  for (const [key, value] of urlParams.entries()) {
    if (key.includes('sources')) {
      sources.push(value);
    }
  }

  // if has sources param(s)
  if (sources.length) {
    // set the checkmark as active for each source in url
    for (let i = 0; i < sources.length; i++) {
      $('#search-form-filter input[value="' + sources[i] + '"]').prop('checked', true);
    }
  }

  // checkbox inputs
  $('#search-form-filter').on('change', function (event) {
    var checkedInputs = $('input[type="checkbox"]:checked').map(function(i, el) {
      return el.value;
    }).get();

    var newPageUrl = window.location.origin + '?s=' + search;
    // if there is a checked input, set the 'source' param
    if (checkedInputs) {
      for (let i = 0; i < checkedInputs.length; i++) {
        newPageUrl += '&sources[]=' + checkedInputs[i];
      }
    }

    // send the user to newly filtered page
    window.location.href = newPageUrl;
  });
}

// ****
// End search post type filter
// ****
    
    
    
// ****
// Author Load More
// ****
    
const loadMore = document.getElementById('load-more')

if (loadMore) {
  loadMore.addEventListener('click', function () {
    console.log('loa-dmore');
    // Select all hidden content elements
    const hiddenDivs = document.querySelectorAll('.hidden-post');
  
    // Reveal the next 3 hidden elements
    for (let i = 0; i < 3 && i < hiddenDivs.length; i++) {
      hiddenDivs[i].classList.remove('hidden-post');
    }
  
    // If no more hidden divs, hide the button
    if (document.querySelectorAll('.hidden-post').length === 0) {
      this.style.display = 'none';
    }
    return false; 
  });
}



